import { WIDE_DESKTOP_MIN_WIDTH } from "@/lib/device-format";
import { useSyncExternalStore } from "react";

let wideQuery: MediaQueryList | undefined;

/** One list for every caller, created on first use (not at import, for tests). */
const getWideQuery = (): MediaQueryList => {
  wideQuery ??= window.matchMedia(`(min-width: ${WIDE_DESKTOP_MIN_WIDTH}px)`);
  return wideQuery;
};

const subscribe = (onChange: () => void): (() => void) => {
  const query = getWideQuery();
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
};

const getIsWide = (): boolean => getWideQuery().matches;

/**
 * Whether the screen is wide enough for three columns side by side (see
 * {@link WIDE_DESKTOP_MIN_WIDTH}), known from the first render and kept in
 * step with a resize.
 */
export const useIsWideDesktop = (): boolean =>
  useSyncExternalStore(subscribe, getIsWide);
